import styled from "styled-components";

export default styled.div`
  height: fit-content;

  .chat-menu {
    position: relative;
    width: 100%;
  }
`;
